import { render, staticRenderFns } from "./VChatMessage.vue?vue&type=template&id=2d917584&"
import script from "./VChatMessage.vue?vue&type=script&lang=ts&"
export * from "./VChatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./VChatMessage.vue?vue&type=style&index=0&id=2d917584&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports